
import Component from '../../../assets/scripts/modules/component';

class Form extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.inputs = [...this.element.querySelectorAll('input, select, textarea')];
    this.submitButton = this.element.querySelector('button[type="submit"], input[type="submit"]');

    // Only validate in HTML5 browsers and when the form 'has-validaiton' class is set.
    if (('noValidate' in this.element) && this.element.classList.contains('has-validation')) {
      this.attachValidation(this.element);
    } else {
      this.element.addEventListener('submit', this.preventMultipleSubmits.bind(this));
    }

  }

  preventMultipleSubmits() {

    this.submitButton.disabled = true;

  }

  attachValidation() {

    this.form.noValidate = true;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.form.addEventListener('blur', this.onSubmit.bind(this));

    for (const input of this.inputs) {
      // Chrome has a bug where the input/change event of an autofilled password isn't reliably fired.
      // Clicking the page triggers the event in that case, but that's not a solution.
      // So we work around it by disabling the password validity check.
      if (!!window.chrome && input.getAttribute('type') === 'password') {
        input.removeAttribute('required');
      }

      input.addEventListener('input', this.onInput.bind(this));
      input.addEventListener('change', this.onInput.bind(this));

      // Prevent invalid fields from showing up when nothings been typed yet...
      input.addEventListener('change', event => event.target.classList.add('has-activated'));
      input.addEventListener('blur', event => event.target.classList.add('has-activated'));
    }

    this.preventMultipleSubmits();

  }

  onSubmit() {

    this.checkFormValidity();
    this.focusFirstInvalidInput();

    if (!this.form.checkValidity()) {
      event.preventDefault();
    } else {
      this.preventMultipleSubmits();
    }

  }

  onInput() {

    this.checkFormValidity();

  }

  checkFormValidity() {

    for (const input of this.inputs) {
      input.checkValidity();

      this.showHideErrorMessage(input);
    }

    this.enableDisableSubmitButton();

  }

  focusFirstInvalidInput() {
    const invalidField = this.element.querySelector('input:invalid, select:invalid, textarea:invalid');

    if (invalidField) {
      invalidField.focus();
    }

  }

  enableDisableSubmitButton() {
    const isValid = this.form.checkValidity();

    this.submitButton.disabled = !isValid;

  }

  showHideErrorMessage() {

    // Do nothing for now. But we can check field.validity here.

  }

}

for (const element of document.querySelectorAll('.form')) {
  element.instance = new Form('form', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/form/form.js